module.exports = __webpack_public_path__ + "static/img/winterwarrior.cffb654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterwarrior.png
// module id = 6EiE
// module chunks = 0